import { useEffect, useState } from "react";
import AppConnectApi from "../../apis/app-connect.api";
import TopPageBack from "../../components/TopPageBack";
import AppConnectCard from "../../components/app-connect/AppConnectCard";
import useAuth from "../../hooks/useAuth";

const apps = [
  {
    app_idx: "",
    app_name: "배민",
    app_id: "??????1234",
    app_password: "127892",
    service_use_yn: false,
    connection_yn: false,
    app_type_code: "01",
  },
  {
    app_idx: "",
    app_name: "요기요",
    app_id: "",
    app_password: "",
    service_use_yn: false,
    connection_yn: false,
    app_type_code: "02",
  },
  {
    app_idx: "",
    app_name: "쿠팡",
    app_id: "",
    app_password: "",
    service_use_yn: false,
    connection_yn: false,
    app_type_code: "03",
  },
];

const AppConnectPage = function () {
  const { ceoInfo } = useAuth();
  const [appConnectList, setAppConnectList] = useState([]);
  async function getAppList() {
    if (!ceoInfo.shop_idx) return;
    const { data } = await AppConnectApi.get(ceoInfo.shop_idx);
    const updatedApps = apps.map((app) => {
      const replacement = data?.data.find(
        (replaceApp) => replaceApp.app_type_code === app.app_type_code
      );
      return replacement ? replacement : app;
    });
    setAppConnectList(updatedApps);
  }
  useEffect(() => {
    getAppList();
  }, []);
  return (
    <>
      <TopPageBack>
        <b>배달 앱 연동</b>
      </TopPageBack>
      {appConnectList.map((item, index) => {
        return (
          <AppConnectCard
            getAppList={getAppList}
            item={item}
            key={index}
          />
        );
      })}
  {/* TODO: show when fee change 
      <div className="mx-6 mt-14 mb-12 gap-9 rounded-2xl bg-[#272A30E5] py-4 px-6 flex items-center justify-between">
        <div className="text-white">
          서비스 이용 요금에 변동이 생겼어요. 납부 관리에서 확인해 보세요.
        </div>
        <div className="text-[#17C5D0] whitespace-nowrap">이동</div>
      </div> */}
    </>
  );
};
export default AppConnectPage;
